import { type Resolver, schemaEuropaceProcessEventsWithoutToken } from 'cpool-schemas';
import type { z } from 'zod';

import { EuropaceProcessEventsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
};

export const schemaLoanRequestResolver_GetEuropaceProcessEvents = EuropaceProcessEventsTableDefinitionZod.extend({
    events: schemaEuropaceProcessEventsWithoutToken,
}).nullable();

export type SchemaLoanRequestResolver_GetEuropaceProcessEvents = z.infer<
    typeof schemaLoanRequestResolver_GetEuropaceProcessEvents
>;

export type LoanRequestResolver_GetEuropaceProcessEvents = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetEuropaceProcessEvents
>;
